import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";
import {ActivatedRoute} from "@angular/router";
import {Brand} from "./Brand";

@Injectable({
   providedIn: 'root'
})
export class ColoreFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService,
               private route: ActivatedRoute
   ) {
   }

   async getColori(vendorSlug=null):Promise<Colore[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/colori` : `/api/colori`
      return new Promise((resolve, reject) => {
         ServerService.instance.getAll(Colore, url).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async postColore(data, vendorSlug=null):Promise<Colore[]> {
      let url = vendorSlug ?`/api/esercizi/${vendorSlug}/colori` : `/api/colori`
      return new Promise((resolve, reject) => {
         ServerService.instance.post( url, data, Colore).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async approvaColore(coloreId) {
      return new Promise((resolve, reject) => {
         ServerService.instance.put( `/api/colori/${coloreId}/approva`, {}, Brand).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async putColore(coloreId, data):Promise<Colore[]> {
      return new Promise((resolve, reject) => {
         ServerService.instance.put( `/api/colori/${coloreId}`, data, Colore).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async deleteColore(coloreId):Promise<Colore[]> {
      return new Promise((resolve, reject) => {
         ServerService.instance.delete( `/api/colori/${coloreId}`, {}, Colore).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

}

export class ColoreData {
  id?: number;
  nome?: string;
}

export class Colore {

  data:ColoreData = {}

  constructor(data:ColoreData) {
    // assegno al mio oggetto data (è un json)
    if(!data) data = {}
    Object.assign(this.data, data)
  }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj(`/api/colori`, queryParams);
      if(path) url.url += path;
      return url.toString()
   }



}
